import { SearchLocationDTO } from "../SearchLocation";

export type LocationSearchFilterId = "search-location-id";

export enum LocationFilterMust {
  INTERSECT = "INTERSECT",
  WITHIN = "WITHIN",
}

export interface LocationFilterDTO {
  id: LocationSearchFilterId;
  location: SearchLocationDTO;
  must: LocationFilterMust;
}
